import { render } from "./MetricTmp.vue?vue&type=template&id=1cdacfea"
import script from "./MetricTmp.vue?vue&type=script&lang=js"
export * from "./MetricTmp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__